import PropTypes from 'prop-types'

export const SVG_ICON_TYPES = {
  checkedCircle: 'checkedCircle',
  close: 'close',
  closeWhite: 'closeWhite',
  creditListEmpty: 'creditListEmpty',
  infoQuestion: 'infoQuestion',
  loyaltyBag: 'loyaltyBag',
  loyaltyCheckedCircle: 'loyaltyCheckedCircle',
  loyaltyDollar: 'loyaltyDollar',
  loyaltyNavigation: 'loyaltyNavigation',
  loyaltyPdpUsp: 'loyaltyPdpUsp',
  loyaltySignUp: 'loyaltySignUp',
  loyaltyStarCircle: 'loyaltyStarCircle',
  pomeloLogo: 'pomeloLogo',
  pomeloLogoPreprod: 'pomeloLogoPreprod',
  pomeloLogoStaging: 'pomeloLogoStaging',
  shopTheLook: 'shopTheLook',
  similarProducts: 'similarProducts',
  wideArrowDown: 'wideArrowDown',
}

/**
 * TODO, migrate icons from this component to new version at common/icon
 *
 * **Tips**
 *
 * When adding new icon, strongly suggest to use https://jakearchibald.github.io/svgomg/ to minify them first.
 */
const SvgIcon = ({ className, onClick, role, type }) => {
  let bodyJsx = null
  const baseSvgProps = { className, role, onClick }

  switch (type) {
    case SVG_ICON_TYPES.pomeloLogo:
      bodyJsx = (
        <svg
          viewBox="0 0 152.3 35"
          xmlns="http://www.w3.org/2000/svg"
          {...baseSvgProps}
        >
          <g fill="#231f20">
            <path d="M30 32a11 11 0 01-3-8 11 11 0 013-8 10 10 0 017-3 10 10 0 018 3 11 11 0 013 8 11 11 0 01-3 8 10 10 0 01-8 3 10 10 0 01-7-3zm7 2c3 0 5-3 5-10 0-6-2-10-5-10-2 0-4 3-4 10 0 6 2 10 4 10zM61 34H50c2 0 3-1 3-4V19c0-2-2-3-4-3l9-3h1v3q3-3 7-3c3 0 4 1 5 4q3-4 7-4c3 0 5 2 5 6v11c0 3 1 4 3 4H75c1 0 2-1 2-4V20c0-3-1-4-3-4a5 5 0 00-3 1 7 7 0 010 2v11c0 3 1 4 2 4H63c1 0 2-1 2-4V20c0-3-1-4-3-4a5 5 0 00-3 1v13c0 3 1 4 2 4zM106 28c-1 4-5 7-9 7a9 9 0 01-7-3 11 11 0 01-3-8 12 12 0 013-8 9 9 0 017-3 8 8 0 017 2 9 9 0 012 7H93c0 5 3 9 7 9a6 6 0 006-4zm-13-7h7c0-5-1-7-3-7s-4 3-4 7zM116 0v30c0 3 1 4 4 4h-13c2 0 3-1 3-4V6c0-2-1-3-3-3l9-3zM124 32a11 11 0 01-3-8 11 11 0 013-8 11 11 0 0115 0 11 11 0 013 8 11 11 0 01-3 8 11 11 0 01-15 0zm7 2c3 0 5-3 5-10 0-6-2-10-5-10-2 0-4 3-4 10 0 6 2 10 4 10zM146 34a4 4 0 010-5 4 4 0 015 0 4 4 0 010 5 4 4 0 01-5 0zM14 21h-3v9c0 2 1 4 3 4H0c2 0 4-2 4-5V7c0-2-2-4-4-4V2h14c4 0 7 1 9 3a8 8 0 014 7c-1 9-13 9-13 9zM11 3v17h1c5 0 7-2 7-8s-2-9-7-9z" />
          </g>
        </svg>
      )
      break
    case SVG_ICON_TYPES.pomeloLogoStaging:
      bodyJsx = (
        <svg
          viewBox="0 0 512 160"
          xmlns="http://www.w3.org/2000/svg"
          {...baseSvgProps}
        >
          <g fill="#DC496C" fillRule="evenodd">
            <path d="M120 28c22 0 37 16 37 37 0 10-3 20-10 27-7 6-16 10-27 10-10 0-19-4-26-10-7-7-10-17-10-27s3-20 10-27c7-6 16-10 26-10zm205 0c21 0 36 15 36 36l-1 5v1h-54v1c2 10 10 16 20 16 8 0 15-4 19-11l13 7c-5 12-17 19-32 19-21 0-37-16-37-38 0-21 15-36 36-36zm118 0c21 0 37 16 37 37 0 10-4 20-10 27-7 6-16 10-27 10-10 0-20-4-26-10-7-7-10-17-10-27s3-20 10-27c6-6 16-10 26-10zm57 50c4 0 6 1 9 3 2 2 3 5 3 8 0 4-1 6-3 8-3 3-5 4-9 4-3 0-5-1-8-4-2-2-3-4-3-8a11 11 0 0111-12zM392 0v100h-17V0h17zM254 29c7 0 12 2 15 6 4 4 6 10 6 17v48h-17V57c0-5-1-8-3-10-1-2-4-4-8-4-3 0-6 1-8 3-2 1-4 4-5 7-2 3-2 7-2 11v36h-17V57c0-5-1-8-3-10-1-2-4-4-8-4-3 0-5 1-8 3-2 1-4 4-5 7-2 3-2 6-2 11v36h-17V31h17v14c1-5 4-9 8-12s8-4 13-4c6 0 10 1 14 4s6 7 7 12c2-5 5-9 9-12s8-4 14-4zM41 0c18 0 34 9 34 31S59 62 42 62H17v38H0V0h41zm79 43c-12 0-20 9-20 22s8 22 20 22c6 0 12-2 15-6 4-4 6-10 6-16 0-13-9-22-21-22zm323 0c-12 0-20 9-20 22s8 22 20 22c6 0 11-2 15-6s6-10 6-16c0-13-9-22-21-22zm-118-1c-9 0-17 7-19 15h38c-2-8-10-15-19-15zM40 15H17v32h23c12 0 18-7 18-16s-6-16-18-16z" />
            <text
              fontFamily="Circular-Book, Circular"
              fontSize="41"
              fontWeight="300"
            >
              <tspan x="163" y="159">
                STAGING
              </tspan>
            </text>
          </g>
        </svg>
      )
      break
    case SVG_ICON_TYPES.pomeloLogoPreprod:
      bodyJsx = (
        <svg
          viewBox="0 0 512 160"
          xmlns="http://www.w3.org/2000/svg"
          {...baseSvgProps}
        >
          <g fill="#0F849E" fillRule="evenodd">
            <path d="M120 28c22 0 37 16 37 37 0 10-3 20-10 27-7 6-16 10-27 10-10 0-19-4-26-10-7-7-10-17-10-27s3-20 10-27c7-6 16-10 26-10zm205 0c21 0 36 15 36 36l-1 5v1h-54v1c2 10 10 16 20 16 8 0 15-4 19-11l13 7c-5 12-17 19-32 19-21 0-37-16-37-38 0-21 15-36 36-36zm118 0c21 0 37 16 37 37 0 10-4 20-10 27-7 6-16 10-27 10-10 0-20-4-26-10-7-7-10-17-10-27s3-20 10-27c6-6 16-10 26-10zm57 50c4 0 6 1 9 3 2 2 3 5 3 8 0 4-1 6-3 8-3 3-5 4-9 4-3 0-5-1-8-4-2-2-3-4-3-8a11 11 0 0111-12zM392 0v100h-17V0h17zM254 29c7 0 12 2 15 6 4 4 6 10 6 17v48h-17V57c0-5-1-8-3-10-1-2-4-4-8-4-3 0-6 1-8 3-2 1-4 4-5 7-2 3-2 7-2 11v36h-17V57c0-5-1-8-3-10-1-2-4-4-8-4-3 0-5 1-8 3-2 1-4 4-5 7-2 3-2 6-2 11v36h-17V31h17v14c1-5 4-9 8-12s8-4 13-4c6 0 10 1 14 4s6 7 7 12c2-5 5-9 9-12s8-4 14-4zM41 0c18 0 34 9 34 31S59 62 42 62H17v38H0V0h41zm79 43c-12 0-20 9-20 22s8 22 20 22c6 0 12-2 15-6 4-4 6-10 6-16 0-13-9-22-21-22zm323 0c-12 0-20 9-20 22s8 22 20 22c6 0 11-2 15-6s6-10 6-16c0-13-9-22-21-22zm-118-1c-9 0-17 7-19 15h38c-2-8-10-15-19-15zM40 15H17v32h23c12 0 18-7 18-16s-6-16-18-16z" />
            <text
              fontFamily="Circular-Book, Circular"
              fontSize="41"
              fontWeight="300"
            >
              <tspan x="74" y="159">
                PRE-PRODUCTION
              </tspan>
            </text>
          </g>
        </svg>
      )
      break
    case SVG_ICON_TYPES.loyaltyNavigation:
      bodyJsx = (
        <svg
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
          {...baseSvgProps}
        >
          <g fill="none" fillRule="evenodd">
            <path d="M0 0h20v20H0z" />
            <path
              d="M7 2.6v.1L8 5l.8-2.2c.5-1.2 2-1.6 2.8-.7h.1l.4.7c.3 1 0 2-.8 2.5h-.1l-.2.1h3c.4 0 .8.4.8.8v2.5c0 .3-.2.6-.4.6h-.6v.6h1C17 9.7 19 11.6 19 14s-2 4.4-4.4 4.4c-1.3 0-2.6-.7-3.4-1.7l-.2.2H3a1 1 0 01-1-.9V9h-.4a.6.6 0 01-.6-.4V6.2c0-.5.4-.9.9-.9h2.9-.1c-.9-.5-1.3-1.6-1-2.6l.5-.6c.8-1 2.2-.7 2.8.5zm7.6 8a3.4 3.4 0 00-3.3 3.5c0 1.9 1.5 3.4 3.3 3.4 2 0 3.4-1.5 3.4-3.4s-1.5-3.4-3.4-3.4zm.3 1l.1.2v.4h.1l.4.2a1.2 1.2 0 01.5.5V13.2l-.6.2v-.1h-.1l-.1-.2-.2-.2h-.3l-.4.1-.2.3.1.2.3.2h.5c.4.2.7.3.8.5.2.2.3.4.3.7 0 .2-.1.5-.3.6 0 .2-.2.2-.3.3l-.4.1v.6H14.4V16h-.1l-.5-.2a1.3 1.3 0 01-.7-.9v-.1l.6-.1h.1v.2l.2.2.3.2h.8l.1-.4v-.2l-.4-.2-.5-.1c-.3 0-.6-.2-.8-.4a.9.9 0 01-.3-.6 1 1 0 01.4-.8l.3-.2.4-.1v-.5l.1-.1h.4zM8.5 9.3V16h2.2a4.4 4.4 0 012-5.8v-1H8.5zM3 9.2V16h4.4V9.2H3zm6-2.9l-.5.3v1.6h5.2V6.5l-.1-.2H9zm-6.8 0H2V8.3h5.3V6.6l-.7-.3H2.2zM9.7 3l-.1.2-.8 2 1.9-.9c.3-.2.5-.6.5-1V3l-.3-.3c-.3-.4-1-.3-1.2.2zm-4.9-.2l-.1.3c-.2.4 0 .9.3 1.1v.1l2 1-.8-2.1V3c-.4-.5-1-.6-1.4-.2z"
              fillOpacity=".8"
              fill="#000"
              fillRule="nonzero"
            />
          </g>
        </svg>
      )
      break
    case SVG_ICON_TYPES.creditListEmpty:
      bodyJsx = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 88 88"
          {...baseSvgProps}
        >
          <g fill="none" opacity=".9">
            <path d="M0 0h88v88H0z" />
            <path
              fill="#979797"
              d="M56.4 17.6c1.9 0 3.4 1.4 3.5 3.1v20.8c4.2 2.3 7.2 6.6 7.8 12l.5-1.4c.2-.5.8-.9 1.3-.8h.2c.5.2.8.8.7 1.3v.2l-1.9 5.1c-.2.7-1 1-1.6.7l-4.5-3a1 1 0 01-.3-1.5c.4-.5 1-.6 1.5-.4h.1l1.9 1.3c-.3-7.8-6-13.2-13.1-13.2-8.5 0-14.3 5-14.3 14.3 0 6.3 6.5 12.1 14.3 12.1 3.6 0 6.3-1.3 9.7-4.5.5-.4 1.2-.4 1.6 0a1 1 0 010 1.6c-3.8 3.6-7 5.1-11.3 5.1a18 18 0 01-11.9-4.5H21a3.4 3.4 0 01-3.4-3v-42c0-1.8 1.4-3.2 3.2-3.3h35.6zm0 2.2H21c-.6 0-1 .4-1.1 1V62.6c0 .6.4 1 1 1.1H38.6a12.6 12.6 0 01-2.7-7.6c0-10.7 7-16.5 16.6-16.5 1.8 0 3.5.3 5 .8V21c0-.6-.4-1-1-1v-.1zM53 45.1c.6 0 1 .4 1.1 1V56.9c0 .2 0 .5-.2.6v.1l-4.6 4.8c-.5.4-1.2.4-1.6 0a1 1 0 01-.2-1.4l.1-.2 4.3-4.3V46.2c0-.6.4-1 1-1l.1-.1zM33.6 44c.6 0 1.1.5 1.1 1.1 0 .6-.4 1-1 1l-.1.1h-6.9c-.6 0-1.1-.5-1.1-1.1 0-.6.4-1 1-1l.1-.1h6.9zm6.8-8.8c.7 0 1.2.5 1.2 1.1 0 .6-.5 1-1 1l-.2.1H26.7c-.6 0-1.1-.5-1.1-1.1 0-.6.4-1 1-1l.1-.1h13.7zm11.3-8.8c.6 0 1.1.5 1.1 1.1 0 .6-.4 1-1 1l-.1.1h-25c-.6 0-1.1-.5-1.1-1.1 0-.6.4-1 1-1l.1-.1h25z"
            />
          </g>
        </svg>
      )
      break
    case SVG_ICON_TYPES.similarProducts:
      bodyJsx = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 12 13"
          {...baseSvgProps}
        >
          <g
            fill="none"
            fillRule="evenodd"
            stroke="#000"
            transform="rotate(180 5.5 6)"
          >
            <path d="M7 11.5H1A1.5 1.5 0 0 1-.5 10V3A1.5 1.5 0 0 1 1 1.5h.5V8A1.5 1.5 0 0 0 3 9.5h5.5v.5A1.5 1.5 0 0 1 7 11.5z" />
            <rect width="9" height="10" x="1.5" y="-.5" rx="1" />
          </g>
        </svg>
      )
      break
    case SVG_ICON_TYPES.checkedCircle:
      bodyJsx = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 19 19"
          {...baseSvgProps}
        >
          <g fill="none">
            <path
              fill="#000"
              d="M9.5 2.8a6.6 6.6 0 016.7 6.7A6.6 6.6 0 019.5 16 6.6 6.6 0 013 9.5a6.6 6.6 0 016.6-6.7m0-1.9A8.5 8.5 0 001 9.5 8.5 8.5 0 009.5 18a8.5 8.5 0 008.6-8.5A8.5 8.5 0 009.5.9z"
            />
            <path stroke="#000" d="M6.4 8.2L9.5 12l8.7-8.6" />
          </g>
        </svg>
      )
      break
    case SVG_ICON_TYPES.shopTheLook:
      bodyJsx = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 23 17"
          {...baseSvgProps}
        >
          <g fill="none" stroke="#000">
            <path d="M11.2 7.3V5.6l.8-.5a2.5 2.5 0 001.2-2 2 2 0 00-2-2.1 2 2 0 00-2 2v1.5M20.3 11.7l-9-4.4-9.1 4.4a2.2 2.2 0 00-1.2 2c0 1.2 1 2.1 2.1 2.1H19.4c1.2 0 2.1-1 2.1-2.1 0-.8-.4-1.6-1.2-2z" />
          </g>
        </svg>
      )
      break
    case SVG_ICON_TYPES.closeWhite:
      bodyJsx = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 18 18"
          {...baseSvgProps}
        >
          <g fill="none" fillRule="evenodd" stroke="#FFF" strokeWidth="2">
            <path d="M1 17L17 1M17 17L1 1" />
          </g>
        </svg>
      )
      break
    case SVG_ICON_TYPES.loyaltyCheckedCircle:
      bodyJsx = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          {...baseSvgProps}
        >
          <path d="M16 0a16 16 0 110 32 16 16 0 010-32zm0 1.2a14.8 14.8 0 100 29.6 14.8 14.8 0 000-29.6zm8.7 8.3a.6.6 0 01.3 1L13.6 23c-.2.3-.6.4-1 .4s-.8-.2-1-.5l-3.5-5a.6.6 0 01.2-.7c.2-.2.6-.1.8.1l3.4 4.9H12.8L24.2 9.8c0-.2.3-.3.5-.3z" />
        </svg>
      )
      break
    case SVG_ICON_TYPES.loyaltyStarCircle:
      bodyJsx = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          {...baseSvgProps}
        >
          <path d="M16 .2a15.8 15.8 0 110 31.6A15.8 15.8 0 0116 .2zm0 1.1a14.7 14.7 0 100 29.4 14.7 14.7 0 000-29.4zm.4 5.2c.3 0 .7.2.9.5v.1l2.3 4.7 5.2.8a1 1 0 01.6 1.7L21.6 18l1 5.2a1 1 0 01-1.1 1.2 1 1 0 01-.5-.1l-4.6-2.4-4.7 2.4a1 1 0 01-1.5-1.1l.9-5.2-3.8-3.6a1 1 0 01.6-1.8l5.2-.8 2.3-4.7c.2-.3.5-.5.8-.6h.2zm0 1.3L14 12.4a1 1 0 01-.8.6l-5 .7 3.6 3.5c.3.3.4.6.3 1l-.8 5 4.5-2.4.5-.1.5.1 4.5 2.4-.9-5c0-.4 0-.7.3-1l3.6-3.5-5-.7a1 1 0 01-.8-.6l-2.2-4.6z" />
        </svg>
      )
      break
    case SVG_ICON_TYPES.loyaltySignUp:
      bodyJsx = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 64 64"
          {...baseSvgProps}
        >
          <g fill="none">
            <path d="M0 0h64v64H0z" />
            <path
              fill="#000"
              d="M41.91 9.14c7.15.02 12.93 5.8 12.95 12.95V41.9A12.97 12.97 0 0141.9 54.86H22.1A12.97 12.97 0 019.14 41.9V22.1A12.97 12.97 0 0122.1 9.14H41.9zm0 1.1H22.1A11.86 11.86 0 0010.25 22.1V41.9a11.86 11.86 0 0011.84 11.84H41.9a11.86 11.86 0 0011.84-11.84V22.1a11.86 11.86 0 00-11.84-11.84zm-5.08 24.44c1.46 0 2.8.82 3.49 2.11l2.03 3.85a1.8 1.8 0 01-1.59 2.64H23.24a1.8 1.8 0 01-1.6-2.64l2.04-3.85a3.96 3.96 0 013.53-2.11h9.62zm-.02 1.1h-9.6c-1.06 0-2.04.6-2.53 1.53l-2.05 3.84a.7.7 0 00.6 1.02h17.53a.7.7 0 00.66-.92l-.04-.1-2.04-3.84a2.84 2.84 0 00-2.53-1.52zm-2.68-14.64a5.56 5.56 0 11-4.26 10.27 5.56 5.56 0 014.26-10.27zm-2.13.68a4.45 4.45 0 100 8.91 4.45 4.45 0 000-8.9zm11.09-4.34c.3 0 .55.25.55.55v2.69h2.69a.55.55 0 110 1.1h-2.69v2.7a.55.55 0 11-1.1 0v-2.7h-2.7a.55.55 0 110-1.1h2.7v-2.69c0-.3.24-.55.55-.55z"
            />
          </g>
        </svg>
      )
      break
    case SVG_ICON_TYPES.loyaltyBag:
      bodyJsx = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 64 64"
          {...baseSvgProps}
        >
          <g fill="none">
            <path d="M0 0h64v64H0z" />
            <path
              fill="#000"
              d="M40.5 10.4l13.1 13a12.1 12.1 0 010 17.1l-13 13.1a12 12 0 01-17.1 0l-13.1-13a12.1 12.1 0 010-17.1l13-13.1a12.1 12.1 0 0117.1 0zM32 7.9a11 11 0 00-7.8 3.2l-13 13a11 11 0 000 15.7l13 13a11 11 0 0015.6 0l13-13a11 11 0 000-15.6l-13-13A11 11 0 0032 7.8zm6.7 13.9c1 0 2 .8 2.1 1.8L43 39.8c0 .6-.1 1.2-.5 1.7-.4.4-1 .7-1.6.7H23.1c-.6 0-1.2-.2-1.6-.7-.4-.5-.6-1-.5-1.7l2-16.1c0-1.1 1-2 2-2h13.7zm0 1H25.1c-.6 0-1 .4-1.1 1l-2 16.1c0 .3 0 .7.3 1 .2.1.5.3.8.3h17.8c.3 0 .6-.2.8-.4.3-.2.4-.6.3-1l-2.2-16c0-.6-.5-1-1-1zm-11 2.7a4.3 4.3 0 008.6 0h1a5.3 5.3 0 01-10.6 0h1z"
            />
          </g>
        </svg>
      )
      break
    case SVG_ICON_TYPES.loyaltyDollar:
      bodyJsx = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 64 64"
          {...baseSvgProps}
        >
          <g fill="none">
            <path d="M0 0h64v64H0z" />
            <path
              fill="#000"
              d="M32 12.6c15.1 0 27.4 8.7 27.4 19.4S47.1 51.4 32 51.4C16.9 51.4 4.6 42.7 4.6 32S16.9 12.6 32 12.6zm0 1C17.4 13.5 5.6 21.7 5.6 32S17.4 50.5 32 50.5 58.5 42.2 58.5 32 46.5 13.5 32 13.5zm1.3 5.7c.2 0 .3 0 .4.2l.2.4v2.5c1.3.3 2.5 1 3.5 2l1 1.4.5 1.4a.6.6 0 01-.4.8l-3.2.9a.7.7 0 01-.5-.1.6.6 0 01-.3-.4 3.7 3.7 0 00-.2-.6l-.4-.7a2.6 2.6 0 00-2.1-.8 2.5 2.5 0 00-1.7.6c-.4.3-.6.7-.6 1.1 0 .3.1.6.3.8l1.2.6 2.6.6c1.9.4 3.3 1.1 4.2 2.2a5.5 5.5 0 011.3 3.6 5.5 5.5 0 01-1.5 3.8c-.5.6-1 1-1.7 1.4a7.2 7.2 0 01-2 .6v2.5c0 .4-.3.6-.6.6h-2.6a.6.6 0 01-.6-.6v-2.4a7.8 7.8 0 01-4.3-2.3 6.7 6.7 0 01-1.7-3.6.6.6 0 01.5-.7l3.2-.8.5.1.2.4c0 .4.2.7.3 1a3 3 0 001.7 1.6c.4.2 1 .2 1.5.2a3 3 0 001.8-.5c.4-.2.6-.6.6-1s-.2-.7-.4-1a2.6 2.6 0 00-1.4-.6l-2.5-.5a7.5 7.5 0 01-3.9-2 5.6 5.6 0 01.2-7.8 7.4 7.4 0 013.7-1.9V20c0-.4.2-.6.6-.6h2.6zm-.4 1h-1.8v2.3c0 .3-.3.6-.6.6a6.4 6.4 0 00-3.4 1.7 4.7 4.7 0 00-1.3 3.4 4.1 4.1 0 001.1 3 6.5 6.5 0 003.4 1.7l2.6.6c.6.1 1.3.4 1.8.9.4.4.7 1 .6 1.5 0 .8-.3 1.5-.9 2a3.9 3.9 0 01-2.4.6c-.7 0-1.3-.1-1.9-.3a3.9 3.9 0 01-2.5-3l-2.5.6a5.7 5.7 0 001.5 2.9 6.6 6.6 0 004 2c.2 0 .5.3.5.6v2.4h1.8v-2.4c0-.3.3-.6.6-.6a6.5 6.5 0 002-.7 5.6 5.6 0 001.4-1.1 4.6 4.6 0 00.1-6.2c-.7-.9-2-1.5-3.6-1.9l-2.6-.5a3.3 3.3 0 01-1.7-.9 2 2 0 01-.6-1.5c0-.7.4-1.4 1-1.8a3.5 3.5 0 012.3-.8 4 4 0 011.6.3 3.5 3.5 0 011.8 1.8l.1.4 2.5-.7-.3-1a4.8 4.8 0 00-.9-1.2 5.9 5.9 0 00-3.2-1.7.6.6 0 01-.5-.6v-2.5z"
            />
          </g>
        </svg>
      )
      break
    case SVG_ICON_TYPES.loyaltyPdpUsp:
      bodyJsx = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 30 30"
          {...baseSvgProps}
        >
          <circle fill="#ededed" cx="15" cy="15" r="15" />
          <path d="M12.6 8v.2l.9 2 .8-2c.5-1.2 1.8-1.6 2.6-.8l.1.1.4.6c.3.9 0 2-.8 2.4l-.2.1h2.8c.4 0 .7.3.8.7V13.7a.6.6 0 01-.5.5H19v.6h.9c2.3 0 4.1 1.8 4.1 4S22.2 23 19.9 23c-1.3 0-2.5-.6-3.2-1.6a.5.5 0 01-.3.2H8.8a.9.9 0 01-.9-.8v-6.6h-.5a.5.5 0 01-.5-.4v-2.4c0-.4.4-.8.8-.8h2.8-.1C9.6 10 9.3 9 9.6 8l.4-.6c.8-.9 2.1-.6 2.6.5zm7.3 7.6a3.2 3.2 0 000 6.5 3.2 3.2 0 000-6.5zm.3 1v.5h.1a1.2 1.2 0 01.4.2 1 1 0 01.4.5 1 1 0 01.1.1v.1l-.6.2-.1-.2-.1-.1-.2-.1a.8.8 0 00-.3-.1l-.4.1-.1.3a.3.3 0 000 .2l.4.2h.5l.7.4c.2.2.3.4.3.7a1 1 0 01-.3.6 1.4 1.4 0 01-.3.3h-.4V21.2h-.5-.1v-.4-.1c-.2 0-.4 0-.5-.2l-.4-.2a1.3 1.3 0 01-.2-.3v-.3l.5-.2h.1v.2a1 1 0 00.2.2.8.8 0 00.6.2l.4-.1a.3.3 0 00.1-.3v-.2a.7.7 0 00-.4-.2h-.5l-.7-.4a.9.9 0 01-.2-.6 1 1 0 010-.4 1 1 0 01.3-.3l.3-.3h.3v-.5l.2-.1h.4zM14 14.3v6.4h2a4.1 4.1 0 011.9-5.5v-.9h-4zm-5.2 0v6.4H13v-6.4H9zm5.7-2.8l-.5.3v1.5H19v-1.6l-.1-.2h-4.3zm-6.5 0l-.1.1v1.7h5v-1.5l-.6-.3H8.1zm7-3l-.7 2 1.8-.9c.3-.1.5-.5.4-.9v-.2a1.1 1.1 0 00-.2-.3c-.4-.4-1-.2-1.2.3zm-4.5-.3a1 1 0 00-.1.3c-.2.4 0 .9.3 1v.1l1.8 1-.7-2v-.1c-.3-.5-1-.7-1.3-.3z" />
        </svg>
      )
      break
    case SVG_ICON_TYPES.wideArrowDown:
      bodyJsx = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 16"
          {...baseSvgProps}
        >
          <path d="M16.2 16a2 2 0 01-1.5-.6l-14-14A.9.9 0 01.8.4.9.9 0 012 .3l14 14h.4L30.3.2a.9.9 0 011.2 1.2l-14 14a2 2 0 01-1.3.5z" />
        </svg>
      )
      break
    case SVG_ICON_TYPES.infoQuestion:
      bodyJsx = (
        <svg
          width="16px"
          height="16px"
          viewBox="0 0 16 16"
          xmlns="http://www.w3.org/2000/svg"
          {...baseSvgProps}
        >
          <g fill="none">
            <circle fill="#0000E5" cx="8" cy="8" r="8" />
            <path
              d="M8.93 9.8v-.2c0-.47.15-.66.87-1.16l.5-.36c1.17-.85 1.44-1.48 1.44-2.28 0-1.42-1.1-2.32-3.34-2.32-2.21 0-3.57 1.06-3.61 2.65 0 .13.02.43.05.6l1.95.16c-.04-.2-.05-.4-.05-.56 0-.8.54-1.23 1.59-1.23.97 0 1.33.5 1.33.93 0 .53-.2.86-1.05 1.48l-.43.33c-.92.67-1 1.04-1 1.66v.3h1.75zm0 2.7v-1.94H7.16v1.94h1.79z"
              fill="#FFF"
            />
          </g>
        </svg>
      )
      break
    case SVG_ICON_TYPES.close:
    default:
      bodyJsx = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 22.35 22.35"
          {...baseSvgProps}
        >
          <g>
            <g>
              <line
                fill="none"
                stroke="#231f20"
                strokeMiterlimit="10"
                strokeWidth="2px"
                x1="0.71"
                y1="21.65"
                x2="21.65"
                y2="0.71"
              />
              <line
                fill="none"
                stroke="#231f20"
                strokeMiterlimit="10"
                strokeWidth="2px"
                x1="21.65"
                y1="21.65"
                x2="0.71"
                y2="0.71"
              />
            </g>
          </g>
        </svg>
      )
      break
  }

  // In case of styling needs
  return bodyJsx
}

SvgIcon.defaultProps = {
  className: '',
  onClick: null,
  role: 'img',
  type: SVG_ICON_TYPES.close,
}

SvgIcon.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  role: PropTypes.oneOf(['application', 'document', 'img']),
  type: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

export default SvgIcon
